module.exports = __webpack_public_path__ + "media/images/watermark-origin-373a3563945f34d24cbb7e0d10ca9a1b.png";